import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Footer } from "@/components/layout/Footer";
import { MarketingHeader } from "@/components/layout/MarketingHeader";

export const Route = createFileRoute("/_marketing")({ component: MarketingLayout });

function MarketingLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <MarketingHeader />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
